import { connect } from 'react-redux'

import values from 'core/data-model/constants/values'
import { getUserAgentType, isLoggedIn } from 'identity/selectors'

const enhance = connect((state) => ({
  currentUserRole: getUserAgentType(state),
  isCurrentUserLoggedIn: isLoggedIn(state),
}))

const IfRole = enhance((props) => {
  const { is, isNot, allowGuest, currentUserRole, render, isLoggedIn, isCurrentUserLoggedIn } = props
  if (allowGuest && !isCurrentUserLoggedIn) return render()
  if (isLoggedIn && isCurrentUserLoggedIn && currentUserRole === is) return render()
  if (isLoggedIn && isCurrentUserLoggedIn && currentUserRole !== isNot) return render()
  return null
})
IfRole.displayName = 'IfRole'

export const ROLE_LB = values.AGENT_TYPE_LB

export const IfRoleIsLB = function(props) {
  return <IfRole {...props} is={ROLE_LB} />
}

export default IfRole
